import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

import data1 from "../../Data/emergencyNumbers/emergencyNumbersDataAll.json";

export default function EmergencyNumbers() {
  useSEO(seoConfig.emergencyNumbers);

  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Телефоны справочных служб
      </h1>

      {/* <h3 className="about-nii__title antiCorruption__title"></h3> */}

      <Accordion data={data1} />
    </section>
  );
}
